import { useCallback } from 'react';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';

import InviteActions from '../actions/invite';
import { api as API } from '../mixins/api';

import FocusedExperience from './FocusedExperience';
import SoloContent from '@repo/ui/components/content/onboarding/SoloContent';
import Buttons from '@repo/ui/components/buttons';
import Panel from '@repo/ui/components/layout/Panel';
import { Paragraph } from '@repo/ui/components/typography/Content';
import Link from '@repo/ui/components/buttons/Link';
import Icon from '@repo/ui/components/ui/Icon';
import urls from '@repo/ui/config/theme/urls';
import { useStore } from '../utils/alt';

import configAuth from '../../shared/auth';
import AppStatusStore from '@/stores/appStatus';
const auth = configAuth();

const StyledPanel = styled(Panel)`
  text-align: center;
`;

function PlatformOfflineCheck({ children }) {
  const { t } = useTranslation(['commonPlat', 'common']);
  const [{ platformStatus, isRateLimitedRefresh }] = useStore(AppStatusStore);

  const handleLogout = useCallback(() => {
    API.accessToken = false;
    API.activeAccessToken = false;
    auth.logout(() => {
      InviteActions.reset();
      window.location = urls.routes.loginUser;
    });
  }, []);

  let message = platformStatus ? String(platformStatus) : '';

  if (message.includes('Rate limited') || isRateLimitedRefresh) {
    message = `It looks like your device tried talking to our servers too fast, which may happen if you open too many tabs at the same time - please wait a few seconds and reload this page to try again.`;
  }

  if (!message) return children;
  return (
    <FocusedExperience>
      <SoloContent>
        <StyledPanel>
          <Icon name="cog" size={'md'} />
          <br />
          <Paragraph>{message}</Paragraph>
          <Buttons.Primary onClick={() => location.reload(true)}>
            {t('common:actions.reloadPage')}
          </Buttons.Primary>
          <Paragraph>
            <Trans i18nKey="common:errors.keepHappening">
              Does this keep happening? Think it's a bug? Help us out by{' '}
              <Link href="https://support.dosomegood.ca/hc/en-us/requests/new" target="_blank">
                {' '}
                submitting a support ticket{' '}
              </Link>
              .
            </Trans>
          </Paragraph>
        </StyledPanel>
      </SoloContent>
      <br />
      <Link onClick={handleLogout}>{t('commonPlat:actions.logout')}</Link>
    </FocusedExperience>
  );
}

export default PlatformOfflineCheck;
